export interface PlatformStyle {
  bg: string;
  color: string;
  label: string;
}

export const getPlatformStyles = (platform: string): PlatformStyle => {
  switch (platform) {
    case 'Switch':
      return {
        bg: '#e60012',
        color: '#ffffff',
        label: 'Switch',
      };
    case 'Switch 2':
      return {
        bg: '#b0000f',
        color: '#ffffff',
        label: 'Switch 2',
      };
    case 'PS5':
      return {
        bg: '#ffffff',
        color: '#000000',
        label: 'PS5',
      };
    case 'PS4':
      return {
        bg: '#003791',
        color: '#ffffff',
        label: 'PS4',
      };
    case 'PS3':
      return {
        bg: '#000000',
        color: '#ffffff',
        label: 'PS3',
      };
    case 'PS2':
      return {
        bg: '#000000',
        color: '#ffffff',
        label: 'PS2',
      };
    case 'PS1':
      return {
        bg: '#000000',
        color: '#ffffff',
        label: 'PS1',
      };
    case 'Steam':
      return {
        bg: '#1b2838',
        color: '#ffffff',
        label: 'Steam',
      };
    case 'PC':
      return {
        bg: '#2b2b2b',
        color: '#ffffff',
        label: 'PC',
      };
    case 'DS':
      return {
        bg: '#d9d9d9',
        color: '#000000',
        label: 'DS',
      };
    case '3DS':
      return {
        bg: '#00a651',
        color: '#ffffff',
        label: '3DS',
      };
    default:
      return {
        bg: '#444444',
        color: '#ffffff',
        label: platform,
      };
  }
};